module.exports = __webpack_public_path__ + "static/638287652.7ee954e6.jpg";